import { Icon } from "@elaniintc/goes-design-system";
import { useRef, useState } from "react";

interface Props {
  onChange?: (value: string) => void;
}

const FilterBasicSearch = ({ onChange }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchText, setSearchText] = useState("");
  return (
    <div className="h-[60px] relative min-w-[356px] p-3">
      <div className="relative">
        <div className="relative bg-neutral-object-accent-silent border border-neutral rounded-lg py-1.5 px-3">
          <Icon
            type="far"
            name="search"
            className="absolute left-2.5 top-1/2 transform -translate-y-1/2 font-normal text-body text-base leading-3xl"
          />
          <input
            ref={inputRef}
            type="text"
            placeholder={"Ingresa tu búsqueda"}
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              if (onChange) onChange(e.target.value);
            }}
            className="w-full pl-[34px] text-lg font-normal bg-transparent border-none outline-none focus:ring-0 text-body placeholder:text-body-quiet"
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBasicSearch;
